import { render } from "./LocalVideo.vue?vue&type=template&id=eb880132&scoped=true"
import script from "./LocalVideo.vue?vue&type=script&lang=js"
export * from "./LocalVideo.vue?vue&type=script&lang=js"

import "./LocalVideo.vue?vue&type=style&index=0&id=eb880132&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb880132"]])

export default __exports__